import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class MovimentoCNJService extends Service {

    recuperarValoresComplementos(numeroMovimentoCnj) {
        return this.getMovimentoCNJApi().recuperarValoresComplementos(numeroMovimentoCnj);
    }

    async transferirMovimentos(sessao, processos, notificarSessao = false) {
        return this.getMovimentoCNJApi().transferirMovimentos(sessao, processos, notificarSessao);
    }
}

export default MovimentoCNJService;
